export default class PlayerEvent {
  constructor(type, enabled = true, data = {}) {
    this.type = type
    this.enabled = enabled
    this.data = data
    this.callback = null
  }

  setCallback(callback) {
    this.callback = callback
  }
}
